"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceNotFoundError = void 0;
class ServiceNotFoundError extends Error {
    constructor(name) {
        super(`ServiceNotFoundError: ${name}`);
        Object.setPrototypeOf(this, ServiceNotFoundError.prototype);
    }
}
exports.ServiceNotFoundError = ServiceNotFoundError;
//# sourceMappingURL=ServiceNotFoundError.js.map